module.exports = __webpack_public_path__ + "static/media/ga.da92141c.svg";